import { z } from 'zod';

import { QuestionDifficultyEnum } from '../../enums';

export const GenerateShortAnswerQuestionSchema = z.object({
  difficulty: z
    .nativeEnum(QuestionDifficultyEnum)
    .optional()
    .describe('Optional difficulty level for the generated question'),
  text: z
    .string()
    .optional()
    .describe(
      'Optional text content to generate question from, overrides file content',
    ),
});

export type IGenerateShortAnswerQuestionDto = z.infer<
  typeof GenerateShortAnswerQuestionSchema
>;
